interface RatingDisplayProps {
  rating: number;
  showNumeric?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export function RatingDisplay({ rating, showNumeric = true, size = 'md' }: RatingDisplayProps) {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  const starSize = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-xl',
  }[size];

  return (
    <div className="flex items-center gap-1">
      <div className={`flex ${starSize}`}>
        {Array(fullStars)
          .fill('★')
          .map((star, i) => (
            <span key={`full-${i}`} className="text-yellow-500">
              {star}
            </span>
          ))}
        {hasHalfStar && <span className="text-yellow-500">☆</span>}
        {Array(emptyStars)
          .fill('☆')
          .map((star, i) => (
            <span key={`empty-${i}`} className="text-muted-foreground/30">
              {star}
            </span>
          ))}
      </div>
      {showNumeric && (
        <span className="text-sm text-muted-foreground ml-1">
          {rating.toFixed(1)}
        </span>
      )}
    </div>
  );
}